import { render, staticRenderFns } from "./PublicInfo.vue?vue&type=template&id=3a6a5c7a&"
import script from "./PublicInfo.vue?vue&type=script&lang=js&"
export * from "./PublicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports